"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PillTooltipContainer = void 0;
var _react = require("@linaria/react");
var _core = require("@linaria/core");
"pnjlzzg";
const PillTooltipContainer = exports.PillTooltipContainer = /*#__PURE__*/(0, _react.styled)("span")({
  name: "PillTooltipContainer",
  class: "p1vzov9j"
});